/** Replaces the list-API item parked/data-viewer-followup-v2's filter-picker-streams.ts worked on. */
import type { ListDataStreams200Item } from "@/api/orval/generated/schemas";

export interface PickerStream {
    id: number;
    name: string;
    unitCategory: string;
    unitCategoryName: string;
    zoneName: string | null;
    inCurrentZone: boolean;
    hostName: string | null;
    /** Above ground, so a buried probe is negative. */
    heightM: number | null;
}

export function toPickerStream(
    item: ListDataStreams200Item,
    context: { currentZoneId: string; zoneName: (zoneId: string) => string | undefined },
): PickerStream {
    const zoneIds = item.latestFragment?.zoneIds ?? [];
    const firstZoneId = zoneIds[0];
    return {
        id: item.id,
        name: item.name ?? item.defaultName,
        unitCategory: item.unitCategory,
        unitCategoryName: item.unitCategoryName,
        zoneName: firstZoneId === undefined ? null : (context.zoneName(firstZoneId) ?? null),
        inCurrentZone: zoneIds.includes(context.currentZoneId),
        hostName: item.hostName,
        heightM: item.latestFragment?.height ?? null,
    };
}
